<template>
  <b-modal
      :hide-footer="true"
      :title="'O Beneficio não foi entregue'"
      centered
      size="md"
      id="tentativa-entrega"
      :visible="false"
      :no-close-on-backdrop="true"
  >
      
      <div>
        <load v-if="loading" mode="table" />
        <div v-else class="row">
          <form class="col-12" @submit.prevent="submit">
            <h3> Faltam {{ this.beneficio.quantidade - this.beneficio.quantidade_entregue }} entregas </h3>
            <div> Registrando tentativa da entrega {{ this.beneficio.quantidade_entregue + 1 }}</div>
            <br/>
            <div class="row">
                <form-input
                    v-model="nome_entregador_tentativa"
                    label="Nome entregador"
                    :required="true"
                />
                <form-calendar
                    :max-date="dataNow"
                    v-model="data_tentativa"
                    label="Data da tentativa"
                    :required="true"
                />
                <form-textarea
                    v-model="descricao_tentativa"
                    label="Observação sobre a tentativa de entrega"
                />
            </div>

            <div class="row pt-1 px-2 d-flex justify-content-end">
                <button
                    type="submit"
                    class="btn btn-success btn-submit"
                >
                    <i class="mdi mdi-content-save" />
                    {{ $t("Salvar") }}
                </button>
            </div>
          </form>
        </div>
      </div>

      <!-- <div
          v-if="loading == false && tentativas.length > 0"
          class="col-12 px-0 mt-2"
      >
          <h5><b>{{ tentativas.length }}</b> tentativa(s) anterior(es)</h5>
          <div  style="max-height: 300px; overflow: auto">
              <div
                  class="border p-2"
                  v-for="tentativa of tentativas"
                  :key="tentativa.id"
              >
                  <p class="mb-1">
                      <b>Data tentativa </b>
                      {{ tentativa.data_tentativa | formatDateHora}}
                  </p>
                  <p class="mb-1">
                      <b>Nome entregador </b>
                      {{ tentativa.nome_entregador }}
                  </p>
                  <p class="mb-1">
                      <b>Observação </b>
                      {{ tentativa.descricao }}
                  </p>
              </div>
          </div>
      </div> -->
  </b-modal>
</template>
<script>
export default {
  props: ["beneficio", "statusAnterior"],
  data() {
      return {
          dataNow                   : moment().format("YYYY/MM/DD"),
          data_tentativa            : new Date,
          nome_entregador_tentativa : "",
          descricao_tentativa       : "",
          quantidade                : 1,
          entregar_tudo             : false,
          loading                   : false,
          tentativas                : [],
          entregas                  : this.beneficio.entregas,
          entrega_id                : 0,
          numero_tentativas         : 0
      };
  },
  methods: {
    submit() {
        if(this.beneficio.proxima_entrega) {
            // ja houve tentativa de entrega, num_tentativa++
            this.entrega_id = this.beneficio.proxima_entrega.id;
            this.numero_tentativas = this.beneficio.proxima_entrega.numero_tentativas;
        } // caso nao, cria tentativa e armazena numero_tentativas = 1, entregue = 0

        this.loading = true;

        let dados = {
            beneficio_id             : this.beneficio.id,
            entrega_id               : this.entrega_id,
            data_tentativa           : this.data_tentativa,
            nome_entregador_tentativa: this.nome_entregador_tentativa,
            descricao_tentativa      : this.descricao_tentativa,
            numero_tentativas        : this.numero_tentativas + 1,
            entregue                 : 0
        };

        dados.id = this.entrega_id;

        axios
            .post("api/dashboard/beneficio/entrega/update", dados)
            .then((response) => {
                this.$snack.success({
                    button: false,
                    text: "Histórico atualizado com sucesso.",
                });
                this.load = false;
            })
            .finally(() => {
                this.loading = false;
                this.$emit("submit");
                if(this.statusAnterior != this.beneficio.status_liberacao) this.saveHistory();
                this.clear();
                this.$bvModal.hide("tentativa-entrega");
            });
        
    },
    saveHistory() {
      let data = "";
      let observacoes = "";

      if (this.data_tentativa) {
          data = moment(this.data_tentativa,"YYYY-MM-DD" ).format("DD/MM/YYYY");
      }

      observacoes = this.descricao_tentativa;

      axios.post("api/dashboard/status/historico", {
          id: this.beneficio.id,
          observacoes: observacoes,
          status_anterior: this.statusAnterior,
          status_atual: this.beneficio.status_liberacao,
          data:  data,
          module: "Beneficio",
          model: "BeneficioLiberado",
      });
    },
    clear() {
        Object.assign(this.$data, this.$options.data.call(this));
    }
  },
};
</script>
